export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '760c2a9f-d717-4e12-bc5e-2491668603a5';
export const MODAL_CLOSE_SEC = 2.5;
